<template>
  <div class="page">
    <div class="layout">
      <TheHeader></TheHeader>
      <div class="main">
        <div class="aside">
          <TheHot @click="onHotClick"></TheHot>
          <TheHistory :list="searchHistory" @click="onHistoryClick" @clearClick="onClearClick"></TheHistory>
        </div>
        <div class="chat">
          <div class="chat-wrapper">
            <div class="chat-wrap" id="chat-wrap" ref="chatWrap">
              <!-- 对话 -->
              <div :class="[
              'chat-item',
              { other: message.type == ANSWER },
              { self: message.type == QUESTION },
            ]" v-for="message in messageList" :key="message.id" :id="`m-${message.id}`">
                <template v-if="message.type == ANSWER">
                  <div class="avatar">
                    <img src="@/assets/img/robothead.png" alt="" />
                    <div class="talk">{{ message.title }}</div>
                  </div>
                  <div class="message">
                    <div class="text">
                      <div class="wrap">
                        <i class="el-icon-loading" v-if="message.loading"></i>
                        <vue-markdown v-if="!message.loading" :source="message.content"></vue-markdown>
                        <div v-if="message.answerType && message.eaUrl && message.eaUrl.length > 0" class="finished-tool">
                          <el-button size="small" type="primary" @click="onShowQrCode(message)">点击扫码</el-button>
                        </div>

                        <div v-if="message.finished && message.choiceList !== ''" class="related-matters">
                          <el-button size="small" type="primary" @click="onGetMoreInfo(message)">了解更多</el-button>
                        </div>

                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="message">
                    <div class="text">
                      <div class="wrap" v-html="message.content"></div>
                    </div>
                  </div>
                  <div class="avatar">
                    <img src="@/assets/img/userAvatar.png" alt="" />
                  </div>
                </template>
              </div>
            </div>
            <div class="stop-answer" v-show="lastAnswer.status === ChatStatus.Pending">
              <el-button class="btn-stop-answer" icon="el-icon-video-pause" @click="onStopChatMessage">停止回答</el-button>
            </div>
          </div>
          <div class="input-wrap">
            <TheInput @confirm="submitInput"></TheInput>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="二维码扫描"
      :visible.sync="qrCodeDialogVisible"
      width="30%"
      >
      <img :src="qrcode" alt="" class="qrcode-img"/>

    </el-dialog>
  </div>
</template>

<script>
import { fetchEventSource } from '@microsoft/fetch-event-source'
import _ from 'lodash'
import VueMarkdown from 'vue-markdown';
import QRCode from 'qrcode'
import {ApiUrl, ApiToken, WelcomeText, WelcomeTitle} from "@config/sys.config";
import {chatApi} from "@/api/chat-api";

const ANSWER = "answer";
const QUESTION = "question";

const ChatStatus = {
  Init: 0,
  Pending: 1,
  Finished: 2,
  Stop: 3,
  Fail: 4
}

export default {
  components: {
    TheHeader: () => import("@comp/TheHeader.vue"),
    TheHot: () => import("@comp/TheHot.vue"),
    TheHistory: () => import("@comp/TheHistory.vue"),
    TheInput: () => import("@comp/TheInput.vue"),
    VueMarkdown
  },
  data() {
    return {
      ChatStatus,
      inputMessage: "",
      messageList: [],
      ANSWER: ANSWER,
      QUESTION: QUESTION,
      inputPopoverShow: false,
      inputPopoverTimeoutHandler: null,

      questionMessage: '',

      conversationMess: [],// 存储 AI和用户 会话消息

      searchHistory: [],
      tempInputs: {
        "ea_slot": "",
        "ea_info": "",
        "ea_url": "[]",
        "ea_qr_code": "[]",
        "ea_slot_record": 0,
        "history": "",
        "choice_type": "0",
        "choice_list": "",
        "current_preferred_pool": "[]",
        "current_ea_pool": "[]",
        "in_ea_mark":"0",
        "navi_map": "",
      },
      qrCodeDialogVisible: false,
      qrcode: '',
      lastAnswer: {
        id: '',
        taskId: '',
        finished: '',
        status: ChatStatus.Init
      },
      userId: 'abc-123',

      showVideoInputing: true
    };
  },
  methods: {
    onShowQrCode (message) {
      let text = message.eaUrl[0]
      QRCode.toDataURL(text, {width: 192, margin: 1}).then(res => {
        this.qrcode = res;
        this.qrCodeDialogVisible = true
      })
    },
    onStopChatMessage() {
      var _this = this;
      let params = {
        user: this.userId
      }
      chatApi.stopChat(this.lastAnswer.taskId, params)
        .then(ret => {
          if(ret.result === 'success') {
            _this.lastAnswer.status = ChatStatus.Stop
            _this.lastAnswer.finished = true
            _this.$message.success('停止回答成功')
          }
        }).catch(error=> {
          console.error(error)
        this.$message.error('停止回答失败')
      })
    },
    onGetMoreInfo() {
      this.submitInput('了解更多', false)
    },
    onHotClick(item) {
      this.submitInput(item.text)
    },
    onHistoryClick(item) {
      this.submitInput(item.key)
    },
    onClearClick() {
      this.searchHistory = [];
      localStorage.removeItem("SearchHistory")
    },

    messageCreator(type, message = '', title, loading = true) {
      const obj = {
        id: Math.random().toString().replace(".", ""),
        time: new Date().getTime(),
        title: title,
        type: type,
        content: `${message}`,
      }
      if(obj.type === ANSWER) {
        obj.loading = loading
      }
      return obj;
    },
    addMessage2Conversation(message) {
      this.messageList.push(message);
      this.inputMessage = "";
      this.scrollToBottom(message)
    },
    scrollToBottom (message) {
      setTimeout(() => {
        let messageDom = document.querySelector(`#m-${message.id}`);
        messageDom.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 10);
    },
    updateMessageInConversation(message) {
      const index = _.findIndex(this.messageList, ['id', message.id])
      this.messageList[index].content += message.content
      this.messageList[index].title = message.title
      this.messageList[index].loading = false

      for(var key in message) {
        if(['title', 'content', 'loading'].indexOf(key) === -1) {
          this.$set(this.messageList[index], key, message[key])
        }
      }
      this.scrollToBottom(message)
    },

    clickMessage(message) {
      this.inputMessage = message;
      this.submitInput();
    },
    submitInput(message, insertHistory = true) {
      this.inputMessage = message
      this.questionMessage = this.inputMessage
      if(this.lastAnswer.finished === false) {
        return this.$message.info('请等上一条回答完成')
      }
      // 添加用户输入的内容
      this.addMessage2Conversation(
        this.messageCreator(QUESTION, this.inputMessage)
      );
      // 添加等待效果
      let emptyAnswer = this.messageCreator(ANSWER);
      this.addMessage2Conversation(emptyAnswer);

      // 请求服务器
      this.searchAnswer(emptyAnswer);

      insertHistory && this.addSearchHistory();

    },

    addSearchHistory() {

      var index = this.searchHistory.findIndex(item=> item.key === this.questionMessage)
      if(index > -1) {
        this.searchHistory.splice(index, 1)
      }

      this.searchHistory.unshift({
        key: this.questionMessage,
        time: new Date().getTime()
      })

      this.searchHistory.splice(6);
      localStorage.setItem("SearchHistory", JSON.stringify(this.searchHistory))
    },

    removeConversationMessById (id) { // 根据id移除会话
      _.remove(this.messageList, ['id', id])
    },

    searchAnswer(message) {

      this.lastAnswer.taskId = '';
      this.lastAnswer.id = message.id;
      this.lastAnswer.status = ChatStatus.Init;
      this.lastAnswer.finished = false;

      var abortController = new AbortController()

      const id = message.id

      fetchEventSource(ApiUrl + "/chat-messages", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + ApiToken // 鉴权
        },
        body: JSON.stringify({
          "inputs": this.tempInputs,
          "query": this.questionMessage,
          "response_mode": "streaming",
          "conversation_id": "",
          "user": this.userId,
        }),
        openWhenHidden: true, // 页面文档被隐藏时会关闭sse链接并在显示时重连 true无论隐藏与否都不关闭
        signal: abortController.signal, // AbortSignal
        onmessage: async (ev) => { // 接收到消息之后填充消息数据
          const data = JSON.parse(ev.data)

          const event = data.event
          if(event === 'message') {
            console.log(data)
            data.answer = data.answer.replace(/\n/g, "</br>");
            const message = {
              id: id,
              content: data.answer,
              title: '为您找到这些'
            }
            message.taskId = data.task_id;
            if(this.lastAnswer.status === ChatStatus.Init) {
              this.lastAnswer.status = ChatStatus.Pending;
            }
            this.lastAnswer.taskId = data.task_id;
            this.updateMessageInConversation(message)
          } else if (event === 'node_finished') {
            const result = data.data
            if (result.status !== 'succeeded') {
              console.error('node_finished出错了：')
              console.error(result.error)
              return
            }

            const outputs = result.outputs
            if (!outputs || !outputs.end_flag || outputs.end_flag !== 1) {
              // 未结束，不做处理
              return
            }
            this.tempInputs = outputs
            console.log('node_finished')
            console.log(data.data.outputs)
            // 完成后处理
            const message = {
              id: id,
              content: '',
              title: '为您找到这些',
              finished: true
            }

            message.relevantKnowledgeList = outputs.relevantKnowledgeList || [];
            message.relevantEaList = outputs.relevantEaList || [];
            message.eaUrl =outputs.ea_url || '';
            message.answerType = outputs.answer_type || '';
            message.choiceList = outputs.choice_list || '';
            message.taskId = data.task_id;
            this.lastAnswer.taskId = data.task_id;
            this.lastAnswer.status = ChatStatus.Finished;
            this.lastAnswer.finished = true;
            this.updateMessageInConversation(message)

          } else if(event === 'error') {
            // 提示错误信息
            console.log(data.message)
            this.lastAnswer.taskId = data.task_id;
            this.lastAnswer.status = ChatStatus.Fail;
            this.lastAnswer.finished = true;
            // 提示错误信息
            this.updateMessageInConversation({id: id, content: '请求失败，请重试', title: '请求失败'})
          } else if(event === 'message_end') {
            // 消息结束事件，收到此事件则代表流式返回结束
            this.lastAnswer.status = ChatStatus.Fail;
            this.lastAnswer.finished = true;
          }

        },
        onopen: (res) => { // 打开
          if (res.status !== 200) {
            console.error('chatMessage失败：', res)
            this.lastAnswer.status = ChatStatus.Fail;
            this.lastAnswer.finished = true;
            this.updateMessageInConversation({id: id, content: '很抱歉，服务器开小差了，请您稍后再试', title: '请求失败'})
          }
        },
        onclose: () => { // 连接关闭
          console.log('连接关闭')
        },
        onerror: (err) => { // 失败
          abortController.abort()
          console.error('chatMessage失败：', err)
          this.lastAnswer.status = ChatStatus.Fail;
          this.lastAnswer.finished = true;
          this.updateMessageInConversation({id: id, content: '很抱歉，服务器开小差了，请您稍后再试', title: '请求失败'})
        }
      })



         /* this.updateMessageInConversation(emptyMessage.id, res, '为您找到这些');


          this.updateMessageInConversation(
            emptyMessage.id,
            `<p>${err}</p>
            <p>[自动回复] 当前系统繁忙，请稍后...</p>
            <p class="link">
              <a href="http://www.baidu.com" target="_blank">去网上看看</a>
            </p>`,
            '出问题了。。。'
          );*/

    },
  },
  mounted() {

    var searchHistory = localStorage.getItem("SearchHistory")
    if(searchHistory) {
      this.searchHistory = JSON.parse(searchHistory)
    }

    this.addMessage2Conversation(
      this.messageCreator(
        ANSWER,
        WelcomeText,
        WelcomeTitle,
        false
      )
    );


  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';

.page {
  .layout {}
  .qrcode-img {
    display: block;
    margin: 0 auto;
  }
  .main {
    display: flex;
    height: 720px;
    width: 1200px;
    position: relative;
    background: #fff;
    border-radius: 14px;
  }

  .aside {
    padding-top: 50px;
    width: $sideWidth;
    background: rgba(246, 249, 254, 1);
  }

  .chat {
    background: url("~@img/chat-bg.png") no-repeat;
    background-size: auto 100%;
    background-position: 100% 100%;
    padding: 20px 0 20px 20px;

    .input-wrap {
      margin-top: 20px;
    }
  }

  .chat-wrapper {
    height: $chatHeight;
    width: $chatWidth;
    position: relative;
    display: flex;
    flex-direction: column;
    .stop-answer {
      text-align: center;
      z-index: 9999;
      margin-top: 10px;
      .btn-stop-answer {
        border-radius: 10px;
      }
    }
  }

  .chat-wrap {
    height: $chatHeight;
    width: $chatWidth;
    overflow-y: auto;
    padding-right: 20px;

    .chat-item {
      width: 100%;

      &+.chat-item {
        margin-top: 14px;
      }

      .avatar {
        display: flex;
        align-items: center;
        user-select: none;

        img {
          width: 50px;
        }

        .talk {
          font-weight: bold;
          font-size: 16px;
          user-select: none;
          margin: 0 14px;
        }
      }

      .message {
        padding: 0 20px;
        max-width: calc( 100% - $avatarWidth * 2 - 40px );


        .text {
          box-shadow: 0 0 8px #e4e4e4;
          margin-top: 10px;
          border-radius: 10px;
          position: relative;

          .wrap {
            height: 100%;
            width: 100%;
            padding: 10px 20px;
            line-height: 2;
            background: #fff;
            border-radius: 10px;
            z-index: 10;
            position: relative;
            border-radius: 0 10px 10px 10px;

            .finished-tool {
              text-align: right;
              margin-top: 10px;
            }

            .related-matters {
              text-align: left;
              margin-top: 10px;
            }
          }
        }
      }

      &.self {
        display: flex;
        justify-content: flex-end;

        .text {
          .wrap {
            background: linear-gradient(90deg, rgba(38, 111, 235, 1) 0%, rgba(66, 135, 255, 1) 100%);
            color: #fff;
            border-radius: 10px 0 10px 10px;
          }
        }
      }
    }
  }

}


</style>
